import moment from "moment";
import "moment-timezone";

// Short relative time config
moment.updateLocale("en", {
  relativeTime: {
    future: "in %s",
    past: "%s ago",
    s: "s",
    ss: "%ds",
    m: "1m",
    mm: "%dm",
    h: "1h",
    hh: "%dh",
    d: "1d",
    dd: "%dd",
    M: "1M",
    MM: "%dM",
    y: "1y",
    yy: "%dy",
  },
});

moment.relativeTimeThreshold("s", 59); // Seconds up to 59s
moment.relativeTimeThreshold("m", 59); // Minutes up to 59m
moment.relativeTimeThreshold("h", 24); // Hours up to 24h

export function todaysDate() {
  return moment().tz("America/New_York").format("dddd, MMMM Do");
}

export function RelativeTime({ date }) {
  return <span>{moment.utc(date).fromNow(true)}</span>;
}

export function formatToEST(dateString) {
  const dateInEST = moment.utc(dateString).tz("America/New_York");
  return {
    long: dateInEST.format("MMM Do, YYYY, h:mm A [ET]"),
    short: dateInEST.format("h:mm A [ET]"),
  };
}

export function convertUnixToEasternTime(unixTimestamp) {
  return moment
    .unix(unixTimestamp)
    .tz("America/New_York")
    .format("MMMM D, YYYY h:mm A z");
}

function formatAsYMD(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getCurrentWeek() {
  const now = new Date();
  const startOfWeek = new Date(now.setDate(now.getDate() - now.getDay()));
  startOfWeek.setHours(0, 0, 0, 0);

  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);

  return {
    startOfWeek: formatAsYMD(startOfWeek),
    endOfWeek: formatAsYMD(endOfWeek),
  };
}

export function getLastWeek() {
  const now = new Date();
  const startOfLastWeek = new Date(
    now.setDate(now.getDate() - now.getDay() - 7)
  );
  startOfLastWeek.setHours(0, 0, 0, 0);

  const endOfLastWeek = new Date(startOfLastWeek);
  endOfLastWeek.setDate(startOfLastWeek.getDate() + 6);

  return {
    startOfLastWeek: formatAsYMD(startOfLastWeek),
    endOfLastWeek: formatAsYMD(endOfLastWeek),
  };
}

export function formatDate(date) {
  return moment(date).format("YYYY-MM-DD");
}
